import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Save, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { api } from '@/lib/api';
import { useSite } from '@/context/SiteContext';
import { errorMessage } from '@/lib/errorMessage';

const PAGES = [
    { id: 'home', label: 'Home' },
    { id: 'atelier', label: "L'atelier" },
    { id: 'matrimoni', label: 'Matrimoni' },
    { id: 'workshop', label: 'Workshop' },
    { id: 'giardini', label: 'Giardini' },
    { id: 'galleria', label: 'Galleria' },
    { id: 'eventi', label: 'Eventi' },
    { id: 'contatti', label: 'Contatti' },
];

export default function SiteSeoPanel() {
    const { seo, reload } = useSite();
    const [form, setForm] = useState({});
    const [savingPage, setSavingPage] = useState(null);

    useEffect(() => { setForm(seo || {}); }, [seo]);

    const savePage = async (pageId) => {
        setSavingPage(pageId);
        try {
            await api.put(`/admin/site/seo/${pageId}`, form[pageId] || {});
            toast.success(`SEO pagina "${pageId}" salvata`);
            await reload();
        } catch (e) {
            toast.error(errorMessage(e, 'Errore salvataggio'));
        } finally { setSavingPage(null); }
    };

    return (
        <div className="space-y-4" data-testid="admin-seo-panel">
            <div>
                <h2 className="font-serif text-xl">SEO</h2>
                <p className="text-xs text-muted-foreground mt-0.5">Meta title, meta description e immagine social per ogni pagina.</p>
            </div>
            {PAGES.map((p) => {
                const val = form[p.id] || {};
                return (
                    <div key={p.id} className="rounded-xl border border-border bg-card p-5">
                        <div className="flex items-center justify-between mb-3">
                            <p className="eyebrow">Pagina: {p.label}</p>
                            <Button size="sm" onClick={() => savePage(p.id)} disabled={savingPage === p.id} className="h-8">
                                {savingPage === p.id ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-1.5" />}
                                Salva
                            </Button>
                        </div>
                        <div className="space-y-3">
                            <div>
                                <Label className="eyebrow">Meta title</Label>
                                <Input value={val.title || ''} onChange={(e) => setForm({ ...form, [p.id]: { ...val, title: e.target.value } })} className="mt-1.5" />
                            </div>
                            <div>
                                <Label className="eyebrow">Meta description</Label>
                                <Textarea rows={2} value={val.description || ''} onChange={(e) => setForm({ ...form, [p.id]: { ...val, description: e.target.value } })} className="mt-1.5" />
                            </div>
                            <div>
                                <Label className="eyebrow">Immagine OpenGraph (URL)</Label>
                                <Input value={val.og_image || ''} onChange={(e) => setForm({ ...form, [p.id]: { ...val, og_image: e.target.value } })} className="mt-1.5 font-mono text-xs" placeholder="https://... o /api/uploads/..." />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
